module.exports = __webpack_public_path__ + "static/club-brewing-a503b4f84e0296ba567ceb5af9524d9f.jpg";